import React, { useEffect, useState } from 'react';
import './LeaderBoards.css';
import Fire from '../../Database/fire.jsx';
import loading from '../loader.svg';
import Navbar from '../Nav/Navbar.jsx';
import Social from '../Socials/Social.jsx';

const LeaderBoards = () => {
  const [leader, setLeader] = useState([]);
  const [loader, setLoader] = useState(false);
  useEffect(() => {
    setLoader(true);
    const getLeaderBoards = async () => {
      let scoreDataArray = [];
      // eslint-disable-next-line
      let tempDataSet = await Fire.collection('ranks')
        .get()
        .then((snapshot) => {
          snapshot.docs.forEach((doc) => {
            scoreDataArray.push(doc.data());
          });
        });

      let sortedScoreData = scoreDataArray.sort((a, b) => {
        return b.score - a.score;
      });
      sortedScoreData = sortedScoreData.slice(0, 100);
      // See the data array sorted one
      // console.log(sortedScoreData);
      setLeader(() => sortedScoreData);
      setLoader(false);
    };
    getLeaderBoards();
  }, []);

  return (
    <div className='container'>
      <Navbar />
      <h1 className='heading'>LEADERBOARDS</h1>
      <div className='leader-table'>
        {loader ? (
          <div className='box'>
            <img src={loading} alt='loading....' />
          </div>
        ) : (
          leader.map((row, index) => (
            <div className='row' key={index + row.name}>
              <div className='index-wrapper'>{index + 1}.</div>
              <div className='name-wrapper'>
                <div className='name-box'>{row.name}</div>
                <div className='country-box'>{row.country}</div>
              </div>
              <div className='score-wrapper'>{row.score}</div>
            </div>
          ))
        )}
      </div>
      <Social />
    </div>
  );
};

export default LeaderBoards;
